import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import "chart.js/auto";
import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Bar, Pie } from "react-chartjs-2";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { ApiCall, FindTranslatedKey, handleDateChange } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import DragableModal, { DateBox, FormButton } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";
import { NotificationSound } from "../CommonComponents/CommonNotification";

ChartJS.register(ArcElement, Tooltip, Legend);
const Dashboard = () => {
    const inputrefs = useRef([]);
    const [dashBoardData, setDashBoardData] = useState({})
    const [boardData, setBoardData] = useState([]);
    var values = boardData.getDashboardChart;
    var data1 = [];
    const [incomeModalShow, setincomeModalShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const selectedDate = new Date();
    selectedDate.setDate(selectedDate.getDate() - 14);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const selectedDate2 = new Date();
    selectedDate2.setDate(selectedDate2.getDate());
    const dateArr = selectedDate.toDateString().split(" ");
    const formattedDate = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    let [modalTabledata, setmodalTabledata] = useState([]);
    const [formData, setFormData] = useState({
        FromDate: formattedDate,
        ToDate: formattedDate1,
    });
    /*modal all functionality start*/
    const [modalKey, setModalKey] = useState("")
    const handleModalShowClose = () => setincomeModalShow(false);
    const handleOpen = async (key) => {
        await setModalKey(key)
        await setincomeModalShow(true)
        await GetModaldata(key)

    };
    const GetModaldata = async (key, CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        setSubLoading(true)
        let GetData = {
            FromDate: formData.FromDate,
            ToDate: formData.ToDate,
            "Type": "S",
            CallType: key,
            PageIndex: PageIndex.toString()
        }
        setLoading(true)
        let data = await ApiCall('/api/Dashboard/ShowDashboardTotalRecord', GetData)
        setLoading(false)
        setmodalTabledata(data)
        setSubLoading(false)

    }


    const handleChange1 = (event, value) => {
        GetModaldata(modalKey, value);
    };

    const exportfunction = (key) => {
        setSubLoading(true)
        let GetData = {
            FromDate: formData.FromDate,
            ToDate: formData.ToDate,
            "Type": "E",
            CallType: key,
        }
        handleDownloadExcel('/api/Dashboard/ShowDashboardTotalRecord', GetData, key)
        setSubLoading(false)
    }
    const formatModalKey = (key) => {
        return key.replace(/([A-Z])/g, ' $1').trim();
    };
    /*modal all functionality End*/
    const data = {
        labels: [
            FindTranslatedKey("Total Cancel Request"),
            FindTranslatedKey("Driver Assigned"),
            FindTranslatedKey("Driver Not Assigned"),
            FindTranslatedKey("In-Scanned"),
            FindTranslatedKey("Pending"),
        ],
        datasets: [
            {
                label: "Data of",
                data: [dashBoardData.cancel ? dashBoardData.cancel : 0, dashBoardData.driverAssign ? dashBoardData.driverAssign : 0, dashBoardData.driverNotAssign ? dashBoardData.driverNotAssign : 0,
                dashBoardData.inScanned ? dashBoardData.inScanned : 0, dashBoardData.pendingInScanned ? dashBoardData.pendingInScanned : 0],
                backgroundColor: [
                    "red",
                    "green",
                    "rgb(65, 84, 241)",
                    "rgb(189, 183, 183)",
                    "orange",
                ],
                borderColor: [
                    "white",
                    "white",
                    "white",
                    "white",
                    "white",
                ],
                borderWidth: 1,
            },
        ],
    };
    if (values !== undefined && values !== null) {
        for (let i = 0; i < values.length; i++) {
            data1.push({
                bookingDate: values[i].bookingDate,
                pending: values[i].pending,
                delivered: values[i].delivered,
                totalOrder: values[i].totalOrder,
            });
        }
    };

    var bookingDate = data1.map((item) => (item.bookingDate));
    var pendingData = data1.map((item) => item.pending);
    var deliveredData = data1.map((item) => item.delivered);
    var totalOrder = data1.map((item) => item.totalOrder);;

    const BarChartvalue = {
        labels: bookingDate,
        datasets: [
            {
                label: FindTranslatedKey("Total Order"),
                backgroundColor: "rgb(0, 172, 230)",
                borderColor: "black",
                data: totalOrder,
            },
            {
                label: FindTranslatedKey("Delivered Data"),
                backgroundColor: "rgb(6, 193, 10)",
                borderColor: "black",
                data: deliveredData,
            },
            {
                label: FindTranslatedKey("Pending Data"),
                backgroundColor: "rgb(255, 179, 102)",
                borderColor: "black",
                data: pendingData,
            },

        ],
    };
    const GetDashboardDetails = async (value) => {
        setSubLoading(true)
        let data = await ApiCall('/api/Dashboard/GetDashboardDetails', { ...formData })
        setSubLoading(false)
        setDashBoardData(data);
    }
    const GetDashboardChart = async (value) => {
        setSubLoading(true)
        let data = await ApiCall('/api/Dashboard/GetDashboardChart', { ...formData })
        setSubLoading(false)
        setBoardData(data);
        if (data.status === 'EXPIRED') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs);
        }
    }
    useEffect(() => {
        document.title = 'Dashboard'
        GetDashboardDetails()
        GetDashboardChart()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div className="form-box mb-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dash-box">
                            <div className="main-card card border-0">
                                <div className="pt-1 row px-3 border-0">
                                    <div className="card-header mb-1">
                                        <h6 className="m-0"> {FindTranslatedKey("DashBoard")} </h6>
                                    </div>
                                    <div className="card-body pb-1">
                                        <div className="row">

                                            <DateBox
                                                inputrefs={inputrefs}
                                                label="Date From"
                                                placeholder="Date From"
                                                id="txtFromDate"
                                                //value={formData.FromDate ? formData.FromDate : ""}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        inputrefs.current["txtToDate"].focus();
                                                    }
                                                }}
                                                required={false}
                                                selected={
                                                    formData.FromDate === ""
                                                        ? ""
                                                        : new Date(formData.FromDate)
                                                }
                                                onChange={(e) =>
                                                    handleDateChange(e, setFormData, formData, "FromDate")
                                                }
                                            />
                                            <DateBox
                                                inputrefs={inputrefs}
                                                label="Date To"
                                                placeholder="Date To"
                                                id="txtToDate"
                                               // value={formData.ToDate ? formData.ToDate : ""}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        inputrefs.current["btnSub"].focus();
                                                    }
                                                }}
                                                required={false}
                                                selected={
                                                    formData.ToDate === ""
                                                        ? ""
                                                        : new Date(formData.ToDate)
                                                }
                                                onChange={(e) =>
                                                    handleDateChange(e, setFormData, formData, "ToDate")
                                                }
                                            />
                                            <div className="col-md-2 mt-3">
                                                <FormButton
                                                    id={"btnSub"}
                                                    Search={true}
                                                    save={false}
                                                    Export={false}
                                                    Reset={false}
                                                    inputrefs={inputrefs}
                                                    handleSubmit={GetDashboardDetails}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row shadow p-1 pb-0 mt-1" style={{ borderLeft: '2px solid #0006ff8f', borderRadius: '5px' }}>
                                            <div className="p-1 ps-3">
                                                <h6 className="m-0">{FindTranslatedKey("Pickup Request")} </h6>
                                            </div>
                                            <div className="col-md mb-3 dashboardBlock"onClick={() => handleOpen('TotalRequest')} >

                                                <div className="card box-1 card-radius border-left dashboardblockhover "
                                                // style={{ color: Record.totalOrderColor }}
                                                >
                                                    <div className="card-body " >
                                                        <div className="row text-center text-dark"  >
                                                            <div className="card-header hoverheadingblockdash">
                                                                <h6 className="m-0">{FindTranslatedKey("Total")}</h6>
                                                            </div>
                                                            <h6 className="mb-2"> {dashBoardData.totalRequest ? dashBoardData.totalRequest : 0} </h6>
                                                            <svg
                                                                stroke="currentColor"
                                                                fill="currentColor"
                                                                strokeWidth="0"
                                                                viewBox="0 0 512 512"
                                                                height="1em"
                                                                width="1em"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                style={{
                                                                    fontSize: "40px",
                                                                    color: "rgb(86, 135, 245)",
                                                                }}
                                                            >
                                                                <path d="M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"></path>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md mb-2 dashboardBlock" onClick={() => handleOpen('Cancel')}>

                                                <div className="card box-2 card-radius border-left dashboardblockhover " //style={{ color: Record.ofdColor }}
                                                >
                                                    <div className="card-body">
                                                        <div className="row text-center text-dark">
                                                            <div className="card-header hoverheadingblockdash ">
                                                                <h6 className="m-0">{FindTranslatedKey("Cancel")}</h6>
                                                            </div>
                                                            <h6 className=" mb-2">
                                                                {dashBoardData.cancel ? dashBoardData.cancel : 0}
                                                            </h6>
                                                            <svg
                                                                stroke="currentColor"
                                                                fill="currentColor"
                                                                strokeWidth="0"
                                                                viewBox="0 0 512 512"
                                                                height="1em"
                                                                width="1em"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                style={{ fontSize: "40px", color: "red" }}
                                                            >
                                                                <path d="M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"></path>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md mb-2 dashboardBlock" onClick={() => handleOpen('DriverAssign')}>

                                                <div className="card box-3 card-radius  border-left dashboardblockhover  " //style={{ color: Record.ofdColor }}
                                                >
                                                    <div className="card-body">
                                                        <div className="row text-center text-dark">
                                                            <div className="card-header hoverheadingblockdash ">
                                                                <h6 className="m-0"> {FindTranslatedKey("Driver Assigned")}</h6>
                                                            </div>
                                                            <h6 className=" mb-2">
                                                                {dashBoardData.driverAssign ? dashBoardData.driverAssign : 0}
                                                            </h6>
                                                            <svg
                                                                stroke="currentColor"
                                                                fill="currentColor"
                                                                strokeWidth="0"
                                                                viewBox="0 0 640 512"
                                                                height="1em"
                                                                width="1em"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                style={{
                                                                    fontSize: "40px",
                                                                    color: "green",
                                                                }}
                                                            >
                                                                <path d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"></path>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md mb-2 dashboardBlock" onClick={() => handleOpen('DriverNotAssign')}>

                                                <div className="card box-4 card-radius border-left dashboardblockhover " //style={{ color: Record.ofdColor }}
                                                >
                                                    <div className="card-body ">
                                                        <div className="row text-center text-dark">
                                                            <div className="card-header hoverheadingblockdash ">
                                                                <h6 className="m-0">{FindTranslatedKey("Driver Not Assigned")} </h6>
                                                            </div>
                                                            <h6 className=" mb-2">
                                                                {dashBoardData.driverNotAssign ? dashBoardData.driverNotAssign : 0}
                                                            </h6>
                                                            <i
                                                                className="fa-solid fa-user-shield"
                                                                style={{ fontSize: "40px", color: "#4154f1", }}
                                                            ></i>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md mb-2 dashboardBlock" onClick={() => handleOpen('InScanned')}>

                                                <div className="card box-5 card-radius  border-left dashboardblockhover " //style={{ color: Record.ofdColor }}
                                                >
                                                    <div className="card-body">
                                                        <div className="row text-center text-dark">
                                                            <div className="card-header hoverheadingblockdash ">
                                                                <h6 className="m-0 ">{FindTranslatedKey("In-Scanned")}</h6>
                                                            </div>
                                                            <h6 className=" mb-2">
                                                                {dashBoardData.inScanned ? dashBoardData.inScanned : 0}
                                                            </h6>
                                                            <svg
                                                                stroke="currentColor"
                                                                fill="currentColor"
                                                                strokeWidth="0"
                                                                viewBox="0 0 640 512"
                                                                height="1em"
                                                                width="1em"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                style={{ fontSize: "40px", color: "rgb(189, 183, 183)" }}
                                                            >
                                                                <path d="M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"></path>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md mb-2 dashboardBlock " onClick={() => handleOpen('PendingInScanned')}>

                                                <div className="card  box-6 card-radius  border-left dashboardblockhover" //style={{ color: Record.ofdColor }}
                                                >
                                                    <div className="card-body">
                                                        <div className="row text-center text-dark">
                                                            <div className="card-header hoverheadingblockdash">
                                                                <h6 className="m-0">{FindTranslatedKey("Pending")}</h6>
                                                            </div>
                                                            <h6 className=" mb-2">
                                                                {dashBoardData.pendingInScanned ? dashBoardData.pendingInScanned : 0}
                                                            </h6>
                                                            <i
                                                                className="fa-regular fa-clock"
                                                                style={{ fontSize: "40px", color: "orange" }}
                                                            ></i>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="d-block d-md-flex mt-3 mx-0 row ">
                                            <div className="col-md-12 col-lg-6 col-sm-12 px-3 mb-2 shadow" style={{ borderLeft: '2px solid #ff00008f', borderRadius: '5px', marginLeft: '-10px', marginRight: '10px' }}>
                                                <div className="p-1">
                                                    <h6 className="m-0"> {FindTranslatedKey("Booking")} </h6>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 mb-3 dashboardBlock" onClick={() => handleOpen('TotalBooked')}>

                                                        <div className="card  box-7 card-radius dashboardblockhover border-left "
                                                        // style={{ color: Record.totalOrderColor }}
                                                        >
                                                            <div className="card-body" >
                                                                <div className="row text-center text-dark"  >

                                                                    <div className="card-header hoverheadingblockdash">
                                                                        <h6 className="m-0"> {FindTranslatedKey("Total")}</h6>
                                                                    </div>
                                                                    <h6 className="mb-2">
                                                                        {dashBoardData.totalBooked ? dashBoardData.totalBooked : 0}
                                                                    </h6>
                                                                    <svg
                                                                        stroke="currentColor"
                                                                        fill="currentColor"
                                                                        strokeWidth="0"
                                                                        viewBox="0 0 512 512"
                                                                        height="1em"
                                                                        width="1em"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        style={{
                                                                            fontSize: "40px",
                                                                            color: "rgb(86, 135, 245)",
                                                                        }}
                                                                    >
                                                                        <path d="M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"></path>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-4 mb-3 dashboardBlock" onClick={() => handleOpen('TotalManifest')}>

                                                        <div className="card box-8 card-radius border-left dashboardblockhover  " //style={{ color: Record.ofdColor }}
                                                        >
                                                            <div className="card-body" >
                                                                <div className="row text-center text-dark">
                                                                    <div className="card-header hoverheadingblockdash">
                                                                        <h6 className="m-0">{FindTranslatedKey("Menifested")}</h6>
                                                                    </div>
                                                                    <h6 className=" mb-2">
                                                                        {dashBoardData.totalManifest ? dashBoardData.totalManifest : 0}
                                                                    </h6>
                                                                    <i
                                                                        className="fa-solid fa-share-from-square"
                                                                        style={{ fontSize: "40px", color: "green" }}
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-4 mb-3 dashboardBlock" onClick={() => handleOpen('PendingManifest')}>

                                                        <div className="card box-9 card-radius border-left dashboardblockhover " //style={{ color: Record.ofdColor }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row text-center text-dark">
                                                                    <div className="card-header hoverheadingblockdash ">
                                                                        <h6 className="m-0">{FindTranslatedKey("Menifest Pending")} </h6>
                                                                    </div>
                                                                    <h6 className=" mb-2">
                                                                        {dashBoardData.pendingManifest ? dashBoardData.pendingManifest : 0}
                                                                    </h6>
                                                                    <i
                                                                        className="fa-solid fa-user-shield"
                                                                        style={{ fontSize: "40px", color: "orange" }}
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-4 mb-3 dashboardBlock" onClick={() => handleOpen('TotalDispatch')}>

                                                        <div className="card box-10 card-radius  border-left dashboardblockhover " //style={{ color: Record.ofdColor }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row text-center text-dark">
                                                                    <div className="card-header hoverheadingblockdash">
                                                                        <h6 className="m-0">{FindTranslatedKey("Dispatched")} </h6>
                                                                    </div>
                                                                    <h6 className=" mb-2">
                                                                        {dashBoardData.totalDispatch ? dashBoardData.totalDispatch : 0}
                                                                    </h6>
                                                                    <svg
                                                                        stroke="currentColor"
                                                                        fill="currentColor"
                                                                        strokeWidth="0"
                                                                        version="1"
                                                                        viewBox="0 0 48 48"
                                                                        enableBackground="new 0 0 48 48"
                                                                        height="1em"
                                                                        width="1em"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        style={{ fontSize: "40px", color: "green" }}
                                                                    >
                                                                        <path
                                                                            fill="#8BC34A"
                                                                            d="M43,36H29V14h10.6c0.9,0,1.6,0.6,1.9,1.4L45,26v8C45,35.1,44.1,36,43,36z"
                                                                        ></path>
                                                                        <path
                                                                            fill="#388E3C"
                                                                            d="M29,36H5c-1.1,0-2-0.9-2-2V9c0-1.1,0.9-2,2-2h22c1.1,0,2,0.9,2,2V36z"
                                                                        ></path>
                                                                        <g fill="#37474F">
                                                                            <circle cx="37" cy="36" r="5"></circle>
                                                                            <circle cx="13" cy="36" r="5"></circle>
                                                                        </g>
                                                                        <g fill="#78909C">
                                                                            <circle cx="37" cy="36" r="2"></circle>
                                                                            <circle cx="13" cy="36" r="2"></circle>
                                                                        </g>
                                                                        <path
                                                                            fill="#37474F"
                                                                            d="M41,25h-7c-0.6,0-1-0.4-1-1v-7c0-0.6,0.4-1,1-1h5.3c0.4,0,0.8,0.3,0.9,0.7l1.7,5.2c0,0.1,0.1,0.2,0.1,0.3V24 C42,24.6,41.6,25,41,25z"
                                                                        ></path>
                                                                        <polygon
                                                                            fill="#DCEDC8"
                                                                            points="21.8,13.8 13.9,21.7 10.2,17.9 8,20.1 13.9,26 24,15.9"
                                                                        ></polygon>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-4 mb-3 dashboardBlock" onClick={() => handleOpen('PendingDispatch')}>

                                                        <div className="card box-11 card-radius border-left dashboardblockhover  " //style={{ color: Record.ofdColor }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row text-center text-dark">
                                                                    <div className="card-header hoverheadingblockdash ">
                                                                        <h6 className="m-0">{FindTranslatedKey("Dispatch Pending")} </h6>
                                                                    </div>
                                                                    <h6 className=" mb-2"> {dashBoardData.pendingDispatch ? dashBoardData.pendingDispatch : 0}
                                                                    </h6>
                                                                    <svg
                                                                        stroke="currentColor"
                                                                        fill="currentColor"
                                                                        strokeWidth="0"
                                                                        viewBox="0 0 640 512"
                                                                        height="1em"
                                                                        width="1em"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        style={{ fontSize: "40px", color: "rgb(189, 183, 183)" }}
                                                                    >
                                                                        <path d="M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"></path>
                                                                    </svg>


                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-lg-6 col-sm-12 px-3 mb-2 shadow" style={{ borderLeft: '2px solid #16b513c7', borderRadius: '5px' }}>
                                                <div className="p-1">
                                                    <h6 className="m-0">{FindTranslatedKey("Status")} </h6>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 mb-3 dashboardBlock " onClick={() => handleOpen('Delivered')} >

                                                        <div className="card box-12 card-radius  border-left dashboardblockhover"
                                                        // style={{ color: Record.totalOrderColor }}
                                                        >
                                                            <div className="card-body" >
                                                                <div className="row text-center text-dark"  >

                                                                    <div className="card-header hoverheadingblockdash">
                                                                        <h6 className="m-0">{FindTranslatedKey("Delivered")}  </h6>
                                                                    </div>
                                                                    <h6 className="mb-2">
                                                                        {dashBoardData.delivered ? dashBoardData.delivered : 0}
                                                                    </h6>
                                                                    <svg
                                                                        stroke="currentColor"
                                                                        fill="currentColor"
                                                                        strokeWidth="0"
                                                                        version="1"
                                                                        viewBox="0 0 48 48"
                                                                        enableBackground="new 0 0 48 48"
                                                                        height="1em"
                                                                        width="1em"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        style={{ fontSize: "40px", color: "green" }}
                                                                    >
                                                                        <path
                                                                            fill="#8BC34A"
                                                                            d="M43,36H29V14h10.6c0.9,0,1.6,0.6,1.9,1.4L45,26v8C45,35.1,44.1,36,43,36z"
                                                                        ></path>
                                                                        <path
                                                                            fill="#388E3C"
                                                                            d="M29,36H5c-1.1,0-2-0.9-2-2V9c0-1.1,0.9-2,2-2h22c1.1,0,2,0.9,2,2V36z"
                                                                        ></path>
                                                                        <g fill="#37474F">
                                                                            <circle cx="37" cy="36" r="5"></circle>
                                                                            <circle cx="13" cy="36" r="5"></circle>
                                                                        </g>
                                                                        <g fill="#78909C">
                                                                            <circle cx="37" cy="36" r="2"></circle>
                                                                            <circle cx="13" cy="36" r="2"></circle>
                                                                        </g>
                                                                        <path
                                                                            fill="#37474F"
                                                                            d="M41,25h-7c-0.6,0-1-0.4-1-1v-7c0-0.6,0.4-1,1-1h5.3c0.4,0,0.8,0.3,0.9,0.7l1.7,5.2c0,0.1,0.1,0.2,0.1,0.3V24 C42,24.6,41.6,25,41,25z"
                                                                        ></path>
                                                                        <polygon
                                                                            fill="#DCEDC8"
                                                                            points="21.8,13.8 13.9,21.7 10.2,17.9 8,20.1 13.9,26 24,15.9"
                                                                        ></polygon>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-4 mb-3 dashboardBlock" onClick={() => handleOpen('RTO')}>

                                                        <div className="card box-13 card-radius  border-left dashboardblockhover  " //style={{ color: Record.ofdColor }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row text-center text-dark">
                                                                    <div className="card-header hoverheadingblockdash ">
                                                                        <h6 className="m-0">{FindTranslatedKey("RTO")} </h6>
                                                                    </div>
                                                                    <h6 className=" mb-2">
                                                                        {dashBoardData.rto ? dashBoardData.rto : 0}
                                                                    </h6>
                                                                    <svg
                                                                        stroke="currentColor"
                                                                        fill="currentColor"
                                                                        strokeWidth="0"
                                                                        viewBox="0 0 1024 1024"
                                                                        height="1em"
                                                                        width="1em"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        style={{ fontSize: "40px", color: "rgb(52, 207, 254)" }}
                                                                    >
                                                                        <path d="M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-4 mb-3 dashboardBlock" onClick={() => handleOpen('OutForDelivery')}>

                                                        <div className="card box-14 card-radius  border-left dashboardblockhover  " //style={{ color: Record.ofdColor }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row text-center text-dark">
                                                                    <div className="card-header hoverheadingblockdash ">
                                                                        <h6 className="m-0">{FindTranslatedKey("OFD")}  </h6>
                                                                    </div>
                                                                    <h6 className=" mb-2">
                                                                        {dashBoardData.outForDelivery ? dashBoardData.outForDelivery : 0}
                                                                    </h6>
                                                                    <i
                                                                        className="fas fa-edit fa-1x "
                                                                        style={{ fontSize: "40px", color: "#f4744c" }}
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-4 mb-3 dashboardBlock" onClick={() => handleOpen('InTransit')}>

                                                        <div className="card box-15 card-radius  border-left dashboardblockhover " //style={{ color: Record.ofdColor }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row text-center text-dark">
                                                                    <div className="card-header hoverheadingblockdash ">
                                                                        <h6 className="m-0">{FindTranslatedKey("Pending")} </h6>
                                                                    </div>
                                                                    <h6 className=" mb-2">{dashBoardData.inTransit ? dashBoardData.inTransit : 0}
                                                                    </h6>
                                                                    <i
                                                                        className="fa-solid fa-user-shield"
                                                                        style={{ fontSize: "40px", color: "red" }}
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-4 mb-3 dashboardBlock" onClick={() => handleOpen('UnDelivered')}>

                                                        <div className="card box-16 card-radius  border-left dashboardblockhover " //style={{ color: Record.ofdColor }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="row text-center text-dark">
                                                                    <div className="card-header hoverheadingblockdash ">
                                                                        <h6 className="m-0">{FindTranslatedKey("Un-Delivered")} </h6>
                                                                    </div>
                                                                    <h6 className=" mb-2">{dashBoardData.unDelivered ? dashBoardData.unDelivered : 0}
                                                                    </h6>
                                                                    <svg
                                                                        stroke="currentColor"
                                                                        fill="none"
                                                                        strokeWidth="2"
                                                                        viewBox="0 0 24 24"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        height="1em"
                                                                        width="1em"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        style={{
                                                                            fontSize: "40px",
                                                                            color: "rgb(224, 84, 74)",
                                                                        }}
                                                                    >
                                                                        <path
                                                                            stroke="none"
                                                                            d="M0 0h24v24H0z"
                                                                            fill="none"
                                                                        ></path>
                                                                        <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                                                                        <path d="M15.585 15.586a2 2 0 0 0 2.826 2.831"></path>
                                                                        <path d="M5 17h-2v-11a1 1 0 0 1 1 -1h1m3.96 0h4.04v4m0 4v4m-4 0h6m6 0v-6h-6m-2 -5h5l3 5"></path>
                                                                        <path d="M3 3l18 18"></path>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row  mt-3'>
                                            <div className='col-xl-4 col-lg-4 p-1'>
                                                <div className="card p-2  mb-4">
                                                    <h6 className="m-0  pt-2 mb-2 text-center"> {FindTranslatedKey("Pickup Status Report")}</h6>
                                                    <Pie data={data} />
                                                </div>
                                            </div>
                                            <div className="col-xl-8 col-lg-8 p-1">
                                                <div className="card mb-4 p-2">
                                                    <h6 className="m-0  pt-2 mb-2 text-center"> {FindTranslatedKey("Day Wise Booking Report")}</h6>
                                                    <div className="chart-area " >
                                                        <Bar data={BarChartvalue} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            < Modal
                show={incomeModalShow} onHide={handleModalShowClose}
                size="lg"

                keyboard={false}
                contentClassName='modaldashboard'
                dialogAs={DragableModal}
            >
                <Modal.Header closeButton >
                    <Modal.Title className='d-flex justify-content-between w-100' style={{ marginBottom: "0px" }}>
                        <h5 style={{ marginBottom: "0px" }}>{`${FindTranslatedKey(formatModalKey(modalKey))} ${FindTranslatedKey('Report')}`}</h5>

                        <div>
                            <button type="button" className="btn btn-rounded btn-warning"
                                onClick={() => exportfunction(modalKey)}
                            >
                                <span className=" text-warning me-2"><i className="fa fa-download text-white color-success"></i>
                                </span>{FindTranslatedKey('Export')}</button>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table
                        PageName={'Dashboard'}
                        loading={loading}
                        Filter={false}
                        tableData={modalTabledata}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                      
                    />
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal >
        </>
    );
};
export default Dashboard;
